import { cloneDeep } from 'lodash';

import {
    ContractInterface,
    OperationInterface,
    OrderType,
    OrderTypeAvailableInterface,
    ProductInterface,
    SelectedProductInterface,
} from '../../../core';
import { OrderTypeAvailable } from './order-type-available';

export class Operation implements OperationInterface {
    private _original?: Operation;
    private _contract: ContractInterface;
    private _product: ProductInterface;
    private _selectedProduct: SelectedProductInterface;
    private _types: OrderTypeAvailableInterface[];
    private _onlyRefund: boolean;
    private _editing: boolean;
    private _readonly: boolean;

    get original(): Operation {
        if (!this._original) {
            this._original = new Operation();
        }

        return this._original;
    }

    get contract(): ContractInterface {
        return this._contract;
    }

    set contract(value: ContractInterface) {
        if (!this.original._contract) {
            this.original._contract = cloneDeep(value);
        }

        this._contract = value;
    }

    get product(): ProductInterface {
        return this._product;
    }

    set product(value: ProductInterface) {
        if (!this.original._product) {
            this.original._product = cloneDeep(value);
        }
        this._product = value;
    }

    get selectedProduct(): SelectedProductInterface {
        return this._selectedProduct;
    }

    set selectedProduct(value: SelectedProductInterface) {
        if (!this.original._selectedProduct) {
            this.original._selectedProduct = cloneDeep(value);
        }
        this._selectedProduct = value;
    }

    get types(): OrderTypeAvailableInterface[] {
        if (this.readonly || this.editing) {
            return [
                new OrderTypeAvailable(OrderType.SUBSCRIPTION),
                new OrderTypeAvailable(OrderType.SUBSCRIPTION_PERIOD),
                new OrderTypeAvailable(OrderType.REFUND),
                new OrderTypeAvailable(OrderType.REFUND_PERIOD),
                new OrderTypeAvailable(OrderType.INTERNAL_TRANSFER),
                new OrderTypeAvailable(OrderType.EXTERNAL_TRANSFER),
            ];
        }

        if (this.onlyRefund) {
            return this._types.filter((it) => it.type === OrderType.REFUND || it.type === OrderType.INTERNAL_TRANSFER);
        }

        return this._types;
    }

    set types(value: OrderTypeAvailableInterface[]) {
        if (!this.original._types) {
            this.original._types = cloneDeep(value);
        }

        this._types = value;
    }

    get onlyRefund(): boolean {
        return this._onlyRefund;
    }

    set onlyRefund(value: boolean) {
        if (!this.original._onlyRefund) {
            this.original._onlyRefund = cloneDeep(value);
        }

        this._onlyRefund = value;
    }

    get editing(): boolean {
        return this._editing;
    }

    set editing(value: boolean) {
        if (!this.original._editing) {
            this.original._editing = cloneDeep(value);
        }

        this._editing = value;
    }

    get readonly(): boolean {
        return this._readonly;
    }

    set readonly(value: boolean) {
        if (!this.original._readonly) {
            this.original._readonly = cloneDeep(value);
        }

        this._readonly = value;
    }
}
